import React, { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import Plus from "../../assets/images/FaPlus.svg";
import FaRegTrashCanUnselect from "../../assets/images/FaRegTrashCanunselect.svg";
import FaRegTrashCan from "../../assets/images/FaRegTrashCan.svg";
import archivered from "../../assets/images/archivered.svg";
import archivegrey from "../../assets/images/archivegrey.svg"
import "./Home.css";
import Tooltip from "@mui/material/Tooltip";
import Fade from "@mui/material/Fade";
import usePagination from "@mui/material/usePagination";
import BsQuestionLg from "../../assets/images/BsQuestionLg.svg"
import archivewhite from "../../assets/images/archivewhite.svg"
import FaRegTrashCanwhite from "../../assets/images/FaRegTrashCanwhite.svg"
import { confirmationArchievedDescription, confirmationArchieveTitle, confirmationDeletedDescription, confirmationDeleteTitle, PROJECT_TYPE, SNACKBAR_TYPES, successArchievedMessage, successDeletedMessage } from "../../constants/constant";
import { resetCreateProjectState } from "../../features/createProject/createProductSlice";
import fileicon from "../../assets/images/file-text.svg";
import fileicoArchive from "../../assets/images/file-textarchive.svg";
import Archiveicon from "../../assets/images/archiveicon.svg";
import Archiveiconactive from "../../assets/images/archiveiconactive.svg"
import ViewProjectTable from "./ViewProjectTable/ViewProjectTable";
import {
  resetCurrentMVOCDetail,
  resetCurrentProjectDetail,
  setArchiveProjectData,
  setProjectData,
  setStepcompleted,
  setTotalArchiveProjects,
  setTotalProjects,
  setUsers,
} from "../../features/product/projectSlice";
import ButtonComponent from "../../components/uikit/components/Button/ButtonComponent";
import { clarityNav } from "../../services/api/clarityNav/apiService";
// import { sso } from "../../services/api/sso/apiService";
import useDebounce from "../../hooks/useDebounce";
import { routespath } from "../../constants";
import SearchInput from "../../components/uikit/components/SearchInput/searchInput";
import ConfirmationModal from "../../components/uikit/components/modals/ConfirmationModal/ConfirmationModal";
import { openSnackbar } from "../../features/snackbar/snackbarslice";
import { resetAttachmentRows } from "../../features/MVOC/mvocSlice";



function Home() {
  const { product } = useSelector((state) => state);
  const [activeTab, setActiveTab] = useState(PROJECT_TYPE.PROJECT);
  const [isHovered, setIsHovered] = useState(false);
  const [isHoverArchive, setIsHoverArchive] = useState(false);
  const [multipleDeleteModal, setMultipleDeleteModal] = useState(false);
  const [multipleArchivedmodal, setMultipleArchivedModal] = useState(false);
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [pageValue, setPageValue] = useState("");
  const [search, setSearch] = useState("");
  const [searchArchive, setSearchArchive] = useState("");
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedArchivePage, setSelectedArchivePage] = useState(1);
  const debouncedSearchValue = useDebounce(search, 2000);
  const debouncedArchiveSearchValue = useDebounce(searchArchive, 2000);
  // const {data:projectData,error}=clarityNav.useProjectListQuery({search:debouncedSearchValue,projectType:"",page:selectedPage})
  // const {data:deletedprojectData}=clarityNav.useProjectListQuery({search:debouncedSearchValue,projectType:"deleted",page:selectedPage},{ refetchOnMountOrArgChange: true })
  const { data: projectData, refetch } = clarityNav.endpoints.projectList.useQuery({ search: debouncedSearchValue, projectType: "", page: selectedPage }, { refetchOnMountOrArgChange: true });
  const { data: deletedprojectData, refetch: refetchDeletedProjects, } = clarityNav.endpoints.projectList.useQuery({ search: debouncedArchiveSearchValue, projectType: "deleted", page: selectedArchivePage }, { refetchOnMountOrArgChange: true });
  const [triggerGetUsersList, { data: userResponse }] = clarityNav.useGetUsersListMutation();
  const userInfo = useSelector((state) => state?.product?.users);
  const [archiveProjectData] = clarityNav.useArchiveProjectMutation();
  const [deleteProjectData] = clarityNav.useDeleteProjectMutation();



  // pagination logic
  const count = activeTab === PROJECT_TYPE.PROJECT ? Math.ceil(product?.totalProjects / 10) : Math.ceil(product?.archiveProjects / 10);
  const { items } = usePagination({
    count: count,
    onChange: (e, page) => {
      if (activeTab === PROJECT_TYPE.PROJECT) {
        setSelectedPage(page);
      } else {
        setSelectedArchivePage(page);
      }
      // handlePagination(page);
    },
  });
  // const handlePagination = (page) => {
  //   if(activeTab === PROJECT_TYPE.PROJECT){
  //     refetch({ search: debouncedSearchValue, projectType: "", page: selectedPage });
  //   }else{
  //     refetch({ search: debouncedArchiveSearchValue, projectType: "deleted", page: selectedArchivePage });
  //   }  
  // };

  // End of pagination logic


  // store all users in redux
  useEffect(() => {
    if (Array.isArray(userResponse)) {
      dispatch(setUsers(userResponse));
    }
    dispatch(resetCurrentProjectDetail())
    dispatch(resetCurrentMVOCDetail())
    dispatch(resetAttachmentRows())
  }, [userResponse]);

  useEffect(() => {
    if (userInfo?.length === 0) {
      triggerGetUsersList({});
    }
  }, []);


  // fetch archived project data
  const fetcharchiveProjectData = () => {
    const { result: { data = [], count = 0 } = {} } = deletedprojectData || {};
    if (!searchArchive) {
      dispatch(setTotalArchiveProjects(count));
    }
    dispatch(setArchiveProjectData(data));
  };
  useEffect(() => {
    if (deletedprojectData && deletedprojectData?.success) {
      fetcharchiveProjectData();
    }
  }, [deletedprojectData]);

  //  Actions to fetch My projects .
  ;
  const getAllProjects = () => {
    const { result: { data = [], count = 0 } = {} } = projectData || {};
    if (!search) {
      dispatch(setTotalProjects(count));
    }
    dispatch(setProjectData(data));
  };
  useEffect(() => {
    if (projectData && projectData?.success) {
      getAllProjects();
    }
  }, [projectData]);

  // update search input state
  const getSearchText = useCallback((value) => {
    if (activeTab === PROJECT_TYPE.PROJECT) {
      setSearch(value);
    } else {
      setSearchArchive(value);
    }
  }, [activeTab]);





  // close delete project modal
  const closeArchivedProjectModal = () => {
    setMultipleArchivedModal(false);
  };
  const closeDeleteProjectModal = () => {
    setMultipleDeleteModal(false);
  }

  // Sets the `anchorEl` state to `null` to close the menu.
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Resets the `stepCompleted` state to `0` when the component mounts.
  useEffect(() => {
    dispatch(setStepcompleted(0));
  }, []);


  // Multi select archived projects
  const multipleArchivedProjects = async () => {
    if (selectedRow?.length > 0) {
      try {
        const payload = {
          project_ids: selectedRow,
        };
        await archiveProjectData(payload).unwrap();
        dispatch(
          openSnackbar({
            message: successArchievedMessage.value,
            type: SNACKBAR_TYPES.SUCCESS,
          })
        );
        await refetch();
        await refetchDeletedProjects();
        setMultipleArchivedModal(false);
      } catch (error) {
        // dispatch(closeLoader());
        handleClose();
        setMultipleArchivedModal(false);
      }
    }
  };
  // Multi select and delete from Archive project lists
  const multipleDeleteProjects = async () => {
    if (selectedRow?.length > 0) {
      try {
        const payload = {
          project_ids: selectedRow,
        };
        await deleteProjectData(payload).unwrap();
        dispatch(
          openSnackbar({
            message: successDeletedMessage.value,
            type: SNACKBAR_TYPES.SUCCESS,
          })
        );
        // Refetch the deleted projects data
        await refetchDeletedProjects();
        await refetch();
        setMultipleDeleteModal(false);
      } catch (error) {
        
        setMultipleDeleteModal(false);
      }
    }
  };
  return (
    <>
      {(product?.totalProjects ?? 0) <= 0 &&
        (product?.archiveProjects ?? 0) <= 0 &&
        search === "" ? (
        <div className="container-fluid mx-auto screenToHeight">
          <div className="show-project">
            <div className="header-title">
              <h4>
                My projects <span className="text-secondary">(0)</span>
              </h4>
              <p>View your saved projects or create new project </p>
            </div>
            <div className="project-container">
              <div className="no-project">
                <div className="project-image">
                  <ul className="loading-project">
                    <li className="list-items">
                      <span className="q-icon">
                        <img src={BsQuestionLg} alt="question" />
                      </span>
                      <div className="anim-line">
                        <span className="row-line-sm"></span>
                        <span className="row-line-lg"></span>
                      </div>
                    </li>
                    <li className="list-items">
                      <span className="q-icon">
                        <img src={BsQuestionLg} alt="question" />
                      </span>
                      <div className="anim-line">
                        <span className="row-line-sm"></span>
                        <span className="row-line-lg"></span>
                      </div>
                    </li>
                    <li className="list-items">
                      <span className="q-icon">
                        <img src={BsQuestionLg} alt="question" />
                      </span>
                      <div className="anim-line">
                        <span className="row-line-sm"></span>
                        <span className="row-line-lg"></span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="no-proj-info">
                  <h4 className="my-3">No saved projects</h4>
                  <p className="mb-3">
                    Click on create project button to add a new project{" "}
                  </p>
                  <NavLink
                    to={routespath[0].createProjectDetails}
                    onClick={() => dispatch(resetCreateProjectState())}
                  >
                    <Button
                      className="pr-3 pl-0 gap-2 btnPrimary"
                      variant="contained"
                      color="primary"
                    >
                      <img src={Plus} alt="add" />
                      Create Project
                    </Button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid mx-auto screenToHeight">
          <div className="d-flex justify-content-xl-between align-items-xl-center align-items-md-start flex-md-column flex-xl-row justify-content-md-start gap-md-3 pb-3 pt-[15px]">
            <div className="d-flex gap-10">
              <Button
                onClick={() => {
                  setPageValue("");
                  setActiveTab(PROJECT_TYPE.PROJECT);
                  setSelectedPage(1);
                }}
                className={`d-flex align-items-center justify-content-between ${activeTab === PROJECT_TYPE.PROJECT
                  ? "btnSecondary"
                  : "btnSecondaryActive"
                  }`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                variant="contained"
                color="secondary"
                disableRipple
                style={{
                  backgroundColor: `${activeTab === PROJECT_TYPE.PROJECT
                    ? "#ffffff"
                    : isHovered
                      ? "#ffffff"
                      : "#eeeef2"
                    }`,
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="iconBgCircle"
                    style={{
                      backgroundColor: `${activeTab === PROJECT_TYPE.PROJECT
                        ? "#ffffff"
                        : isHovered
                          ? "#ffffff"
                          : "#eeeef2"
                        }`,
                    }}
                  >

                    <img
                      src={activeTab === PROJECT_TYPE.PROJECT ? fileicon : fileicoArchive}
                      alt={activeTab === PROJECT_TYPE.PROJECT ? "File Icon" : "File Icon Archive"}
                      style={{
                        backgroundColor: activeTab === PROJECT_TYPE.PROJECT
                          ? "#ffffff"
                          : isHovered
                            ? "#ffffff"
                            : "#eeeef2",
                        color: activeTab === PROJECT_TYPE.PROJECT || isHovered ? "#00CA9F" : "#25282B",
                        borderRadius: "4px", // Optional for rounded background if needed
                      }}
                    />
                  </span>
                  <span
                    className="btnTextSize"
                    style={{
                      fontFamily: `${activeTab === PROJECT_TYPE.PROJECT
                        ? "Montserrat-Bold"
                        : isHovered
                          ? "Montserrat-Medium"
                          : "Montserrat-Medium"
                        }`,
                      fontWeight: `${activeTab === PROJECT_TYPE.PROJECT
                        ? "700"
                        : isHovered
                          ? "500"
                          : "500"
                        }`,
                    }}
                  >
                    My projects
                  </span>
                </div>
                <span className="ms-2 btnCountWidth">
                  {product?.totalProjects}
                </span>{" "}
              </Button>
              <Button
                onClick={() => {
                  setPageValue("");
                  setActiveTab(PROJECT_TYPE.ARCHIVED);
                  setSelectedArchivePage(1);
                }}
                className={`d-flex align-items-center justify-content-between ${activeTab === PROJECT_TYPE.ARCHIVED
                  ? "btnSecondary"
                  : "btnSecondaryActive"
                  }`}
                variant="outlined"
                onMouseEnter={() => setIsHoverArchive(true)}
                onMouseLeave={() => setIsHoverArchive(false)}
                disableRipple
                style={{
                  backgroundColor: `${activeTab === PROJECT_TYPE.PROJECT
                    ? "#ffffff"
                    : isHoverArchive
                      ? "#fff"
                      : "#eeeef2"
                    }`,
                }}
               
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="iconBgCircle"
                    style={{
                      backgroundColor: `${activeTab === PROJECT_TYPE.PROJECT
                        ? "#eeeef2"
                        : isHoverArchive
                          ? "#ffffff"
                          : "#ffffff"
                        }`,
                    }}
                  >
                    <img
                      src={
                        activeTab === PROJECT_TYPE.PROJECT
                          ? isHoverArchive
                            ? Archiveiconactive
                            : Archiveicon
                          : isHoverArchive
                            ? Archiveiconactive
                            : Archiveiconactive
                      }
                      alt={isHoverArchive ? "Archive Icon Active" : "Archive Icon"}
                      style={{
                        color: activeTab === PROJECT_TYPE.PROJECT
                          ? isHoverArchive
                            ? "#00CA9F"
                            : "#25282B"
                          : "#00CA9F",
                        height: "20px",
                      }}
                    />

                  </span>
                  <span
                    className={`btnTextSize ${activeTab === PROJECT_TYPE.PROJECT
                      ? "projectTab"
                      : isHoverArchive
                        ? "archiveHoverTab"
                        : "defaultTab"}`}
                  >
                    Archive
                  </span>
                </div>
                <span className="ms-2 btnCountWidth">
                  {product?.archiveProjects}
                </span>{" "}
              </Button>
            </div>
            <div className="d-flex gap-2">

              <SearchInput
                placeholder="Search..."
                value={activeTab === PROJECT_TYPE.PROJECT ? search : searchArchive}
                onChange={getSearchText}
                className="search-input-toggler"
                type="text"
                iconPosition="left"
              />


              {activeTab === PROJECT_TYPE.PROJECT ? (
                <Tooltip
                  TransitionComponent={Fade}
                  TransitionProps={{ timeout: 400 }}
                  title="Archive Projects"
                  arrow
                  placement="left-start"
                >
                  <span>
                    <Button
                      className={
                        selectedRow <= 0
                          ? "btnDanger d-flex gap-2 cursor-notallowed"
                          : "btnDanger cursor-pointer d-flex gap-2"
                      }
                      disableRipple
                      color="error"
                      onClick={() => setMultipleArchivedModal(true)}
                      disabled={selectedRow <= 0}
                      sx={{
                        "&.Mui-disabled": {
                          pointerEvents: "unset",
                          cursor: "not-allowed",
                        },
                        
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      <span>
                        <img
                          src={ selectedRow <= 0
                            ? archivegrey
                            : isHovered
                            ? archivewhite
                            : archivered}
                          alt={selectedRow <= 0 ? "Archive Grey" : "Archive Red"}
                          style={{ height: "20px" }}
                        />{" "}
                      </span>
                      <span
                        className={
                          selectedRow <= 0 ? "pointer-events-none" : ""
                        }
                      >
                        Archive Projects
                      </span>
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Tooltip
                  TransitionComponent={Fade}
                  TransitionProps={{ timeout: 400 }}
                  title="Delete Projects"
                  arrow
                  placement="left-start"
                >
                  <span>
                    <Button
                      className={
                        selectedRow <= 0
                          ? "btnDanger d-flex gap-2 cursor-notallowed"
                          : "btnDanger cursor-pointer d-flex gap-2"
                      }
                      disableRipple
                      variant="contained"
                      color="error"
                      onClick={() => setMultipleDeleteModal(true)}
                      disabled={selectedRow <= 0}
                      sx={{
                        "&.Mui-disabled": {
                          pointerEvents: "unset",
                          cursor: "not-allowed",
                        },
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      <span className="p-0">
                        <img
                          src={selectedRow <= 0 ? FaRegTrashCanUnselect : isHovered
                            ? FaRegTrashCanwhite: FaRegTrashCan}
                          alt={selectedRow <= 0 ? "undelete" : "delete"}
                        />
                      </span>{" "}
                      <span
                        className={
                          selectedRow <= 0 ? "pointer-events-none" : ""
                        }
                      >
                        Delete Projects
                      </span>
                    </Button>
                  </span>
                </Tooltip>
              )}

              <NavLink
                to={routespath[0].createProjectDetails}
                onClick={() => dispatch(resetCreateProjectState())}
              >
                <ButtonComponent
                  variant="contained"
                  btnType="primary"
                  text="Create Project"
                  className="btnPrimary"
                  children={
                    <img
                      src={Plus}
                      alt="add"
                      className="addIconSize"
                      style={{ color: "#ffffff" }}
                    />
                  }
                />
              </NavLink>
            </div>
          </div>

          <div className="container-fluid px-0">
            <ViewProjectTable
              data={
                activeTab === PROJECT_TYPE.PROJECT
                  ? product?.projectsData
                  : product.archiveProjectsData
              }
              projectType={
                activeTab === PROJECT_TYPE.PROJECT
                  ? PROJECT_TYPE.PROJECT
                  : PROJECT_TYPE.ARCHIVED
              }
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              getAllProjects={getAllProjects}
              activeTab={activeTab}
              handleClose={handleClose}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              setMultipleDeleteModal={setMultipleDeleteModal}
              setMultipleArchivedModal={setMultipleArchivedModal}
              items={items}
              // handlePagination={handlePagination}
              pageValue={pageValue}
              setPageValue={setPageValue}
              selectedPage={activeTab === PROJECT_TYPE.PROJECT ? selectedPage : selectedArchivePage}
              setSelectedPage={
                activeTab === PROJECT_TYPE.PROJECT
                  ? setSelectedPage
                  : setSelectedArchivePage
              }
            />
          </div>
          <ConfirmationModal
            openConfirmation={multipleDeleteModal}
            setOpenConfirmation={(e) => setMultipleDeleteModal(e)}
            onConfirm={multipleDeleteProjects}
            confirmationTitle={confirmationDeleteTitle}
            confirmationDescription={confirmationDeletedDescription}
            activeTab={activeTab}
          />
          <ConfirmationModal
            openConfirmation={multipleArchivedmodal}
            setOpenConfirmation={(e) => setMultipleArchivedModal(e)}
            onConfirm={multipleArchivedProjects}
            confirmationTitle={confirmationArchieveTitle}
            confirmationDescription={confirmationArchievedDescription}
            activeTab={activeTab}
          />

        </div>
      )}
    </>
  );
}

export default Home;
